import EnvironmentUtils from '../../utils/environment.utils';
import { AnalyticsConsentService } from '../analytics/analytics-consent.service';
import { GTagEvent } from './types';

export class GtagService {
    static event(event: GTagEvent | string, params?: Gtag.CustomParams | Gtag.ControlParams | Gtag.EventParams | undefined) {
        if (EnvironmentUtils.isProd && AnalyticsConsentService.hasConsent() && typeof window !== 'undefined' && typeof gtag === 'function') {
            gtag('event', event, params);
        }
    }
}
